(function () {
  'use strict';

  angular
    .module('rcv',
      [
        'ngAnimate',
        'ngSanitize',
        'ngDialog',
        'restangular',
        'ui.router',
        'ui.utils.masks',
        'idf.br-filters',
        'toastr',
        'slick',
        'environment.config' // criado dinamicamente, nem tente achar ele no projeto
      ]
    );
})();

(function () {
  'use strict';

  angular
    .module('rcv')
    .directive('rcvNavbar', rcvNavbar);

  /** @ngInject */
  function rcvNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/_components/navbar/navbar.html',
      scope: {
        creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController(moment) {
      var vm = this;

      // "vm.creation" is avaible by directive option "bindToController: true"
      //vm.relativeDate = moment(vm.creationDate).fromNow();
    }
  }

})();

// moment.js locale configuration
// locale : brazilian portuguese (pt-br)
// author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
(function () {
  'use strict';

  (function (factory) {
    if (typeof define === 'function' && define.amd) {
      define(['moment'], factory); // AMD
    } else if (typeof exports === 'object') {
      module.exports = factory(require('../moment')); // Node
    } else {
      factory(window.moment); // Browser global
    }
  }(function (moment) {
    return moment.defineLocale('pt-br', {
      months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
      monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
      weekdays: 'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split('_'),
      weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
      weekdaysMin: 'dom_2ª_3ª_4ª_5ª_6ª_sáb'.split('_'),
      longDateFormat: {
        LT: 'HH:mm',
        L: 'DD/MM/YYYY',
        LL: 'D [de] MMMM [de] YYYY',
        LLL: 'D [de] MMMM [de] YYYY [às] LT',
        LLLL: 'dddd, D [de] MMMM [de] YYYY [às] LT'
      },
      calendar: {
        sameDay: '[Hoje às] LT',
        nextDay: '[Amanhã às] LT',
        nextWeek: 'dddd [às] LT',
        lastDay: '[Ontem às] LT',
        lastWeek: function () {
          return (this.day() === 0 || this.day() === 6) ?
            '[Último] dddd [às] LT' : // Saturday + Sunday
            '[Última] dddd [às] LT'; // Monday - Friday
        },
        sameElse: 'L'
      },
      relativeTime: {
        future: 'em %s',
        past: '%s atrás',
        s: 'segundos',
        m: 'um minuto',
        mm: '%d minutos',
        h: 'uma hora',
        hh: '%d horas',
        d: 'um dia',
        dd: '%d dias',
        M: 'um mês',
        MM: '%d meses',
        y: 'um ano',
        yy: '%d anos'
      },
      ordinal: '%dº'
    });
  }));
})();
(function () {
  'use strict';
  angular.module("ngLocale", [], ["$provide", function ($provide) {
    var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
    $provide.value("$locale", {
      "DATETIME_FORMATS": {
        "AMPMS": [
          "AM",
          "PM"
        ],
        "DAY": [
          "domingo",
          "segunda-feira",
          "ter\u00e7a-feira",
          "quarta-feira",
          "quinta-feira",
          "sexta-feira",
          "s\u00e1bado"
        ],
        "ERANAMES": [
          "Antes de Cristo",
          "Ano do Senhor"
        ],
        "ERAS": [
          "a.C.",
          "d.C."
        ],
        "FIRSTDAYOFWEEK": 6,
        "MONTH": [
          "janeiro",
          "fevereiro",
          "mar\u00e7o",
          "abril",
          "maio",
          "junho",
          "julho",
          "agosto",
          "setembro",
          "outubro",
          "novembro",
          "dezembro"
        ],
        "SHORTDAY": [
          "dom",
          "seg",
          "ter",
          "qua",
          "qui",
          "sex",
          "s\u00e1b"
        ],
        "SHORTMONTH": [
          "jan",
          "fev",
          "mar",
          "abr",
          "mai",
          "jun",
          "jul",
          "ago",
          "set",
          "out",
          "nov",
          "dez"
        ],
        "STANDALONEMONTH": [
          "janeiro",
          "fevereiro",
          "mar\u00e7o",
          "abril",
          "maio",
          "junho",
          "julho",
          "agosto",
          "setembro",
          "outubro",
          "novembro",
          "dezembro"
        ],
        "WEEKENDRANGE": [
          5,
          6
        ],
        "fullDate": "EEEE, d 'de' MMMM 'de' y",
        "longDate": "d 'de' MMMM 'de' y",
        "medium": "d 'de' MMM 'de' y HH:mm:ss",
        "mediumDate": "d 'de' MMM 'de' y",
        "mediumTime": "HH:mm:ss",
        "short": "dd/MM/yy HH:mm",
        "shortDate": "dd/MM/yy",
        "shortTime": "HH:mm"
      },
      "NUMBER_FORMATS": {
        "CURRENCY_SYM": "R$",
        "DECIMAL_SEP": ",",
        "GROUP_SEP": ".",
        "PATTERNS": [
          {
            "gSize": 3,
            "lgSize": 3,
            "maxFrac": 3,
            "minFrac": 0,
            "minInt": 1,
            "negPre": "-",
            "negSuf": "",
            "posPre": "",
            "posSuf": ""
          },
          {
            "gSize": 3,
            "lgSize": 3,
            "maxFrac": 2,
            "minFrac": 2,
            "minInt": 1,
            "negPre": "-\u00a4",
            "negSuf": "",
            "posPre": "\u00a4",
            "posSuf": ""
          }
        ]
      },
      "id": "pt-br",
      "localeID": "pt_BR",
      "pluralCat": function (n) {
        if (n >= 0 && n <= 2 && n != 2) {
          return PLURAL_CATEGORY.ONE;
        }
        return PLURAL_CATEGORY.OTHER;
      }
    });
  }]);
})();
(function () {
  'use strict';

  angular
    .module('rcv')
    .directive('rcvFooter', rcvFooter);

  /** @ngInject */
  function rcvFooter() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/_components/footer/footer.html',
      scope: {
        creationDate: '='
      },
      controller: FooterController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function FooterController() {
      var vm = this;

    }
  }

})();

(function () {
  'use strict';

  angular
    .module('rcv')
    .controller('PageController', PageController);

  /** @ngInject */
  function PageController() {
    var vm = this;

    vm.faq_list = [
      {title: 'O que é CDI e CDM?', answer: 'CDI é a abreviação para Código da Instituição e CDM é a abreviação para Código da Matrícula. Elas são informadas no seu cartão REDECONV.'},
      {title: 'Como cadastro meu Estabelecimento?', answer: 'Muito simples. Faça sua simulação na página principal e preencha os dados do formulário. Feito isso, a REDECONV entrará em contato com você rapidamente e dará todos os detalhes!'},
      {title: 'Qual a taxa da Redeconv?', answer: 'A REDECONV trabalha de forma flexível. Em média, cobramos 3% de taxa, porém esse valor é negociável de acordo com o cliente. Entre em contato para encontrarmos um valor especial para o seu negócio!'},
      {title: 'Não lembro minha senha do cartão. E agora?', answer: 'Por questões de segurança entre em contato com a REDECONV através do telefone +55 (69) 3224-6509 para orientarmos na recuperação de sua senha do cartão.'},
      {title: 'Como vejo meu saldo e extrato?', answer: 'Você pode acessar no próprio site da REDECONV no menu superior direito em "ACESSO AO PORTAL" e selecionar "ASSOCIADO". Entre com seus dados e verá. Ou utilize nossos aplicativos para Android e iPhone. Basta procurar por "Redeconv" nas lojas Google Play ou AppStore, instalar e usar!'},
      {title: 'Perda ou extravio do cartão', answer: 'Em caso de perda ou extravio/roubo do seu cartão ligue imediatamente para a Redeconv através do número 69 3224-6509 para bloqueá-lo.'}
    ]
  }
})();
(function () {
  'use strict';

  angular
    .module('rcv')
    .controller('MainController', MainController)
    .controller('ContactController', ContactController);

  /** @ngInject */
  function MainController(Restangular, anchorSmoothScroll, toastr, $state, $location, $timeout, $scope, ngDialog) {
    var vm = this;
    vm.text_simulate = 'Simular';

    vm.doIt = function () {

      $scope.data = {
        fuel: vm.fuel,
        feeding: vm.feeding,
        food: vm.food,
        agreement: vm.agreement
      };

      ngDialog.open({
        template: 'templateModal',
        className: 'ngdialog-theme-default',
        width: 500,
        scope: $scope
      });
    };

    vm.doSimulate = function (again) {

      if (!again) {
        vm.showHire = false;
      }

      var data_simulate = {}, nil = 0;

      if (angular.isDefined(vm.fuel))       { data_simulate['fuel']       = vm.fuel;      }
      else { nil += 1; }
      if (angular.isDefined(vm.feeding))    { data_simulate['feeding']    = vm.feeding;   }
      else { nil += 1; }
      if (angular.isDefined(vm.food))       { data_simulate['food']       = vm.food;      }
      else { nil += 1; }
      if (angular.isDefined(vm.agreement))  { data_simulate['agreement']  = vm.agreement; }
      else { nil += 1; }

      // os 4 estao vazios, nao executa
      if (nil === 4) { return; }

      if (vm.text_simulate !== 'Simular') { return; }
      if (!again) { vm.text_simulate = 'Simulando, aguarde...'; }

      Restangular
        .one('simulate')
        .customPOST({data: data_simulate})
        .then(function (d) {
          if (d.data.success) {
            if (!again) {
              vm.showHire = true;
              $timeout(function() {
                anchorSmoothScroll.scrollTo('hire');
              }, 100);
            }

            vm.text_simulate = 'Simular';

            /////////////////

            var r = d.data.response;

            // combustivel
            if (r.fuel) {
              vm.fuel.tax       = r.fuel.tax;
              vm.fuel.total     = r.fuel.amount;
              vm.fuel.subtotal  = r.fuel.subtotal;
            }

            // alimentacao
            if (vm.feeding) {
              vm.feeding.tax      = r.feeding.tax;
              vm.feeding.total    = r.feeding.amount;
              vm.feeding.subtotal = r.feeding.subtotal;
            }

            // refeicao
            if (vm.food) {
              vm.food.tax       = r.food.tax;
              vm.food.total     = r.food.amount;
              vm.food.subtotal  = r.food.subtotal;
            }

            // convenio
            if (vm.agreement) {
              vm.agreement.tax      = r.agreement.tax;
              vm.agreement.total    = r.agreement.amount;
              vm.agreement.subtotal = r.agreement.subtotal;
            }
          }
        }, function () {
          vm.text_simulate = 'Simular';
          toastr.error('Erro na requisição. Favor, tentar novamente mais tarde.');
        });
    };

    // ANCHOR
    vm.gotoElement = function (id) {
      $timeout(function () {
        if ($location.$$path === '/') {
          $state.go('home');
        }
      }, 10);

      $timeout(function () {
        anchorSmoothScroll.scrollTo(id);
      }, 300);
    };

    // TOGGLE MENU DROPDOWN
    vm.toggleDD = function() {
      angular.element('.nav li .dropdown-menu').toggleClass('active');
    }
  }

  /** @ngInject */
  function ContactController(toastr, ngDialog, Restangular) {
    var vm = this;

    vm.sendIt = function() {
      // desabilita
      vm.disableBtn = true;

      var data_simulate = {};

      if (angular.isDefined(vm.simulate.fuel))       { data_simulate['fuel']       = vm.simulate.fuel;      }
      if (angular.isDefined(vm.simulate.feeding))    { data_simulate['feeding']    = vm.simulate.feeding;   }
      if (angular.isDefined(vm.simulate.food))       { data_simulate['food']       = vm.simulate.food;      }
      if (angular.isDefined(vm.simulate.agreement))  { data_simulate['agreement']  = vm.simulate.agreement; }

      data_simulate['info'] = {
        'company_name'  : vm.company_name,
        'cnpj'          : vm.cnpj,
        'name'          : vm.name,
        'phone_number'  : vm.phone_number,
        'need'          : vm.need,
        'obs'           : vm.obs
      };

      Restangular
        .one('simulate')
        .customPOST({data: data_simulate, send: true})
        .then(function () {
          ngDialog.close();
          toastr.success('Dados enviado com sucesso! Entraremos o mais breve possível com você!');
        });
    }
  }

  // SCROLL BOX SHADOW
  $(window).scroll(function () {
    var scroll  = $(window).scrollTop();
    var nav     = $(".navigation");

    nav.toggleClass('active', scroll > 280);
  });
})();
(function () {
  'use strict';

  angular
    .module('rcv')
    .service('anchorSmoothScroll', anchorSmoothScroll);

  /** @ngInject */
  function anchorSmoothScroll() {
    var vm = this;

    vm.scrollTo = function (eID) {

      // This scrolling function
      // is from http://www.itnewb.com/tutorial/Creating-the-Smooth-Scroll-Effect-with-JavaScript

      var startY  = currentYPosition();
      var stopY   = elmYPosition(eID);
      var distance = stopY > startY ? stopY - startY : startY - stopY;
      if (distance < 100) {
        scrollTo(0, stopY);
        return;
      }
      // var speed = Math.round(distance / 100);
      // if (speed >= 1000) speed = 1000;
      var speed = 25;
      var step  = Math.round(distance / 25);
      var leapY = stopY > startY ? startY + step : startY - step;
      var timer = 0;
      if (stopY > startY) {
        for (var i = startY; i < stopY; i += step) {
          setTimeout("window.scrollTo(0, " + leapY + ")", timer * speed);
          leapY += step;
          if (leapY > stopY) { leapY = stopY; }
          timer++;
        }
        return;
      }
      for (var i = startY; i > stopY; i -= step) {
        setTimeout("window.scrollTo(0, " + leapY + ")", timer * speed);
        leapY -= step;
        if (leapY < stopY) { leapY = stopY; }
        timer++;
      }

      function currentYPosition() {
        // Firefox, Chrome, Opera, Safari
        if (self.pageYOffset) { return self.pageYOffset; }
        // Internet Explorer 6 - standards mode
        if (document.documentElement && document.documentElement.scrollTop)
          return document.documentElement.scrollTop;
        // Internet Explorer 6, 7 and 8
        if (document.body.scrollTop) { return document.body.scrollTop; }
        return 0;
      }

      function elmYPosition(eID) {
        var elm = document.getElementById(eID);
        var y = elm.offsetTop;
        var node = elm;
        while (node.offsetParent && node.offsetParent != document.body) {
          node = node.offsetParent;
          y += node.offsetTop;
        }
        return y;
      }

    };
  }
})();
(function () {
  'use strict';

  angular
    .module('rcv')
    .directive('numbers', numbers)
    .directive('upcased', upcased);

  ////////////////////

  function numbers() {
    return {
      require: 'ngModel',
      link: function (scope, element, attr, ngModelCtrl) {
        function fromUser(text) {
          if (text) {
            var transformedInput = text.replace(/[^0-9]/g, '');

            if (transformedInput !== text) {
              ngModelCtrl.$setViewValue(transformedInput);
              ngModelCtrl.$render();
            }
            return transformedInput;
          }
          return undefined;
        }

        ngModelCtrl.$parsers.push(fromUser);
      }
    }
  }

  function upcased() {
    return {
      require: 'ngModel',
      link: function(scope, element, attrs, modelCtrl) {
        modelCtrl.$parsers.push(function(input) {
          return input ? input.toUpperCase() : "";
        });
        element.css("text-transform","uppercase");
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('rcv')
    .run(runBlock);

  /** @ngInject */
  function runBlock($timeout) {
    /**
     * Remove o 'CARREGANDO..' apos iniciar toda
     * a execucao do app.
     */
    $timeout(function () {
      angular.element('body.loading').removeClass('loading');
    }, 100);
  }
})();

(function () {
  'use strict';

  angular
    .module('rcv')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $locationProvider, $urlRouterProvider) {
    /**
     * Desabilita hashbang das urls (/#/action)
     */
    $locationProvider.html5Mode(true);

    $stateProvider
      .state('sobre', {
        url: '/sobre',
        templateUrl: 'app/pages/sobre.html',
        controller: 'PageController',
        controllerAs: 'page'
      })

      .state('faq', {
        url: '/faq',
        templateUrl: 'app/pages/faq.html',
        controller: 'PageController',
        controllerAs: 'page'
      })

      .state('home', {
        url: '/',
        templateUrl: 'app/main/main.html',
        controller: 'MainController',
        controllerAs: 'main'
      });

    $urlRouterProvider.otherwise('/');
  }

})();

/* global moment:false */
(function () {
  'use strict';

  angular
    .module('rcv')
    .constant('moment', moment);

})();

(function () {
  'use strict';

  angular
    .module('rcv')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig, RestangularProvider, ENV) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Set options third-party lib
    toastrConfig.allowHtml          = true;
    toastrConfig.timeOut            = 3000;
    toastrConfig.positionClass      = 'toast-top-right';
    toastrConfig.preventDuplicates  = true;
    toastrConfig.progressBar        = true;

    /**
     * API EndPoint
     */
    RestangularProvider.setBaseUrl(ENV.API_URL);
    RestangularProvider.setFullResponse(true);
  }
})();

angular.module("environment.config", [])
.constant("ENV", {"API_URL":"http://www.redeconv.com.br/client"});

angular.module("rcv").run(["$templateCache", function($templateCache) {$templateCache.put("app/main/main.html","<div id=\"wrapper\"><div class=\"row bottom-xs bottom-sm bottom-md bottom-lg center-xs center-sm center-md center-lg\"><div style=\"display: block; width: 100%;\" class=\"the-slideshow\"><slick dots=\"true\" infinite=\"true\" autoplay=\"true\" autoplayspeed=\"5500\" speed=\"2000\" slides-to-show=\"1\" arrows=\"false\" touch-move=\"true\" slides-to-scroll=\"1\"><div class=\"slide1\"><div class=\"row center-xs center-sm center-md center-lg\"><div class=\"box adjustments\"><div class=\"col-lg-10\"></div></div></div></div><div class=\"slide2\"><div class=\"row center-xs center-sm center-md center-lg\"><div class=\"box adjustments\"><div class=\"col-lg-10\" ng-controller=\"MainController as main\"><h1>Cadastre sua instituição ou seu estabelecimento</h1><a href=\"\" ng-click=\"main.gotoElement(\'contratar\');\"><p>FAÇA UMA SIMULAÇÃO.</p></a></div></div></div></div><div class=\"slide3\"><div class=\"row center-xs center-sm center-md center-lg\"><div class=\"box adjustments\"><div class=\"col-lg-10\"><h1>Baixe nosso aplicativo para iPhone e Android!</h1><div class=\"stores\"><a href=\"https://itunes.apple.com/br/app/redeconv/id493441331?l=en&mt=8\" target=\"_blank\" style=\"margin-top: 20px;\"><img src=\"../assets/images/app-store.png\"></a> <a href=\"https://play.google.com/store/apps/details?id=com.ro.redeconv2\" target=\"_blank\" style=\"margin-left: 20px; margin-top: 20px;\"><img src=\"../assets/images/play-store.png\"></a></div></div></div></div></div></slick></div></div><div class=\"row middle-lg middle-md middle-sm middle-xs center-xs center-sm center-md center-lg advantages\" id=\"vantagens\"><div class=\"col-lg-9 col-md-9 col-sm-12 col-xs-12\"><div class=\"box\"><h2 class=\"top\">Vantagens</h2><div class=\"row center-xs center-sm center-md center-lg around-xs around-sm around-md around-lg details\"><div class=\"row col-lg-4 center-xs\"><div class=\"box left\"><h3>Combustível</h3><p>Cuidamos da frota da sua empresa</p></div></div><div class=\"row col-lg-4 center-xs\"><div class=\"box middle\"><h3>Alimentação e Refeição</h3><p>Acesso aos melhores estabelecimentos</p></div></div><div class=\"row col-lg-4 center-xs\"><div class=\"box right\"><h3>Convênio</h3><p>Se precisar, damos uma força financeira</p></div></div></div><h2>e tem muito mais</h2><div class=\"row center-xs center-sm center-md center-lg around-xs around-sm around-md around-lg more\"><div class=\"row col-lg-4 start-xs fill-xs\"><div class=\"box\"><ul><li>Parcele em até 4x</li><li>Compre em diversas cidades</li></ul></div></div><div class=\"row col-lg-4 start-xs fill-xs\"><div class=\"box\"><ul><li>Alerta de compra no celular</li><li>Cheque o saldo no aplicativo e web</li></ul></div></div><div class=\"row col-lg-4 start-xs fill-xs\"><div class=\"box\"><ul><li>Taxas flexíveis</li><li>Recarga de celular online</li></ul></div></div></div></div></div></div><div class=\"row hidden-sm hidden-md hidden-lg center-xs\"><a href=\"http://sistema.redeconv.com.br/ar/propostas/new_estabelecimento\" class=\"btn btn-primary\">CREDENCIE SEU ESTABELECIMENTO</a></div><div class=\"row top-lg top-md top-sm top-xs center-xs center-sm center-md center-lg hidden-xs simulate\"><div class=\"ribbon-wrapper\"><div class=\"ribbon\"></div></div><div class=\"col-lg-9 col-md-9 col-sm-12 col-xs-12\"><div class=\"box\"><h3 class=\"top\">Faça uma simulação e contrate em minutos</h3><small class=\"sub\">É muito fácil ter acesso aos nosso serviços</small></div></div></div><div class=\"row top-lg top-md top-sm top-xs center-xs center-sm center-md center-lg hidden-xs simulate-form\" id=\"contratar\"><div class=\"col-lg-9 col-md-9 col-sm-12 col-xs-12\"><div class=\"box\"><p>Preencha os dados do cartão para os colaboradores da sua empresa</p></div><div class=\"row\" id=\"hire\"><div class=\"col-sm-3 col-md-3 col-lg-3 center-xs bottom-xs\"><div class=\"box\"><img src=\"../../assets/images/card-sample.png\"></div></div><div class=\"col-sm-9 col-md-9 col-lg-9\"><div class=\"row between-sm choose\"><div class=\"col-xs-3\"><div class=\"row\"><form class=\"the-form\"><label><input type=\"checkbox\" ng-model=\"main.fuel.check\"> Combustível</label> <input type=\"text\" placeholder=\"Quantidade\" maxlength=\"6\" numbers=\"\" ng-disabled=\"!main.fuel.check\" ng-model=\"main.fuel.amount\"> <input type=\"text\" placeholder=\"Valor\" ui-money-mask=\"\" ng-disabled=\"!main.fuel.check\" ng-model=\"main.fuel.value\"></form></div></div><div class=\"col-xs-3\"><div class=\"row\"><form class=\"the-form\"><label><input type=\"checkbox\" ng-model=\"main.feeding.check\"> Alimentação</label> <input type=\"text\" placeholder=\"Quantidade\" maxlength=\"6\" numbers=\"\" ng-disabled=\"!main.feeding.check\" ng-model=\"main.feeding.amount\"> <input type=\"text\" placeholder=\"Valor\" ui-money-mask=\"\" ng-disabled=\"!main.feeding.check\" ng-model=\"main.feeding.value\"></form></div></div><div class=\"col-xs-3\"><div class=\"row\"><form class=\"the-form\"><label><input type=\"checkbox\" ng-model=\"main.food.check\"> Refeição</label> <input type=\"text\" placeholder=\"Quantidade\" maxlength=\"6\" numbers=\"\" ng-disabled=\"!main.food.check\" ng-model=\"main.food.amount\"> <input type=\"text\" placeholder=\"Valor\" ui-money-mask=\"\" ng-disabled=\"!main.food.check\" ng-model=\"main.food.value\"></form></div></div><div class=\"col-xs-3\"><div class=\"row\"><form class=\"the-form\"><label><input type=\"checkbox\" ng-model=\"main.agreement.check\"> Convênio</label> <input type=\"text\" placeholder=\"Quantidade\" maxlength=\"6\" numbers=\"\" ng-disabled=\"!main.agreement.check\" ng-model=\"main.agreement.amount\"> <input type=\"text\" placeholder=\"Valor\" ui-money-mask=\"\" ng-disabled=\"!main.agreement.check\" ng-model=\"main.agreement.value\"></form></div></div></div><div class=\"clearfix\"></div><a href=\"\" class=\"btn btn-primary\" id=\"btn-simulate\" ng-click=\"main.doSimulate()\">{{main.text_simulate}}</a></div></div><div class=\"row\" ng-show=\"main.showHire\"><div class=\"col-sm-3 col-md-3 col-lg-3 center-xs bottom-xs\"><div class=\"box tip\">Em média, nossa taxa de serviço é de 3%. Mas estamos abertos para negociar sua proposta! Você pode mudar a % de taxa de serviço que você deseja pagar.</div></div><div class=\"col-sm-9 col-md-9 col-lg-9\"><div class=\"row between-sm hire\"><div class=\"col-xs-3\"><div class=\"row\" ng-show=\"main.fuel.total\"><form class=\"the-form\"><label>Taxa de serviço</label> <input type=\"text\" placeholder=\"%\" ui-percentage-mask=\"1\" ui-percentage-value=\"\" ng-model=\"main.fuel.tax\"> <label class=\"total\">Valor total</label> <span class=\"amount\" ng-bind-html=\"main.fuel.total || 0.0 | finance:true\"></span> <label class=\"total\">Sub total</label> <span class=\"amount\" ng-bind-html=\"main.fuel.subtotal || 0.0 | finance:true\"></span></form></div></div><div class=\"col-xs-3\"><div class=\"row\" ng-show=\"main.feeding.total\"><form class=\"the-form\"><label>Taxa de serviço</label> <input type=\"text\" placeholder=\"%\" ui-percentage-mask=\"\" ui-percentage-value=\"\" ng-model=\"main.feeding.tax\"> <label class=\"total\">Valor total</label> <span class=\"amount\" ng-bind-html=\"main.feeding.total || 0.0 | finance:true\"></span> <label class=\"total\">Sub total</label> <span class=\"amount\" ng-bind-html=\"main.feeding.subtotal || 0.0 | finance:true\"></span></form></div></div><div class=\"col-xs-3\"><div class=\"row\" ng-show=\"main.food.total\"><form class=\"the-form\"><label>Taxa de serviço</label> <input type=\"text\" placeholder=\"%\" ui-percentage-mask=\"\" ui-percentage-value=\"\" ng-model=\"main.food.tax\"> <label class=\"total\">Valor total</label> <span class=\"amount\" ng-bind-html=\"main.food.total || 0.0 | finance:true\"></span> <label class=\"total\">Sub total</label> <span class=\"amount\" ng-bind-html=\"main.food.subtotal || 0.0 | finance:true\"></span></form></div></div><div class=\"col-xs-3\"><div class=\"row\" ng-show=\"main.agreement.total\"><form class=\"the-form\"><label>Taxa de serviço</label> <input type=\"text\" placeholder=\"%\" ui-percentage-mask=\"\" ui-percentage-value=\"\" ng-model=\"main.agreement.tax\"> <label class=\"total\">Valor total</label> <span class=\"amount\" ng-bind-html=\"main.agreement.total || 0.0 | finance:true\"></span> <label class=\"total\">Sub total</label> <span class=\"amount\" ng-bind-html=\"main.agreement.subtotal || 0.0 | finance:true\"></span></form></div></div></div><div class=\"clearfix\"></div><a href=\"/\" class=\"btn btn-primary\" ng-click=\"main.doIt()\">Quero mais detalhes!</a> <a href=\"\" class=\"btn btn-transparent\" ng-click=\"main.doSimulate(\'again\')\">Recalcular taxas</a></div></div><div class=\"clearfix\"></div><div style=\"text-align: center; border-top: 1px solid #c8e5f4; margin-top: 20px; padding-top: 10px;\"><h2>Quer seu Estabelecimento credenciado na Redeconv?</h2><a href=\"http://sistema.redeconv.com.br/ar/propostas/new_estabelecimento\" class=\"btn btn-primary\">Credencie aqui!</a></div></div></div><rcv-footer></rcv-footer></div><script type=\"text/ng-template\" id=\"templateModal\"><h4>É só isso! Agora preencha alguns dados sobre seu negócio. É rápido...</h4> <form class=\"the-form\" name=\"contactForm\" style=\"font-size: 14px;\" ng-controller=\"ContactController as contact\"> <label>Nome da empresa</label> <input type=\"text\" maxlength=\"100\" ng-model=\"contact.company_name\" upcased required> <label>CNPJ (apenas os números)</label> <input type=\"text\" maxlength=\"14\" numbers ng-model=\"contact.cnpj\" required> <label>Nome para contato</label> <input type=\"text\" maxlength=\"80\" ng-model=\"contact.name\" upcased required> <label>Telefone para contato</label> <input type=\"text\" maxlength=\"20\" ng-model=\"contact.phone_number\" ui-br-phone-number required> <label>Qual a sua necessidade?</label> <select name=\"need\" class=\"select-need\" ng-model=\"contact.need\" required> <option value=\"budget\">Solicitar Orçamento</option> <option value=\"proposal\">Solicitar Proposta para meus Colaboradores</option> <option value=\"accredit\">Credenciar Estabelecimento</option> </select> <label>Alguma observação?</label> <textarea ng-model=\"contact.obs\"></textarea> <div ng-init=\"contact.simulate=data\"></div> <div style=\"text-align: center;\"> <button class=\"btn btn-primary\" id=\"btn-send\" ng-click=\"contact.sendIt()\" ng-disabled=\"contactForm.$error.required || contact.disableBtn\">Solicitar contato!</button> </div> </form></script>");
$templateCache.put("app/pages/faq.html","<div id=\"wrapper\"><div class=\"row middle-lg middle-md middle-sm middle-xs center-xs center-sm center-md center-lg page\" id=\"faq\"><div class=\"col-lg-7 col-md-9 col-sm-12 col-xs-12\"><div class=\"box\"><h2 class=\"top\">Perguntas Frequentes</h2><div class=\"the-form\"><input type=\"text\" ng-model=\"word\" placeholder=\"Digite sua dúvida...\"></div><div class=\"row center-xs center-sm center-md center-lg around-xs around-sm around-md around-lg\"><p>Organizamos as respostas para as dúvidas mais frequentes de nossos clientes aqui. Caso você não ache a resposta para ela, você sempre pode falar direto com a gente em <strong>contato@redeconv.com.br</strong> ou por telefone <strong>+55 69 3224-6509</strong></p><ul class=\"answer\" ng-controller=\"PageController as page\"><li ng-repeat=\"faq in page.faq_list | filter: word\"><span class=\"title\">{{faq.title}}</span> <span class=\"content\">{{faq.answer}}</span></li></ul></div></div></div></div><rcv-footer></rcv-footer></div>");
$templateCache.put("app/pages/sobre.html","<div id=\"wrapper\"><div class=\"row middle-lg middle-md middle-sm middle-xs center-xs center-sm center-md center-lg page\" id=\"sobre\"><div class=\"col-lg-7 col-md-9 col-sm-12 col-xs-12\"><div class=\"box\"><h2 class=\"top\">Redeconv do Brasil</h2><div class=\"row center-xs center-sm center-md center-lg around-xs around-sm around-md around-lg content\"><p>Com mais de um milhão de clientes, a Redeconv é líder regional em benefícios, convênios, <em>private label</em> e soluções em pagamentos.</p><p>Utilizando tecnologia de ponta, oferecemos soluções altamente competitivas em pagamentos eletrônicos. Com cobertura em toda a região norte do Brasil, oferecemos nossos serviços para grandes capitais e também áreas inacessíveis da Amazõnia, ajudando pequenas empresas e comunidades a crescerem.</p><p>A Redeconv é uma empresa homologada pelo Banco Central do Brasil e credenciada pelo PAT do Governo Federal.</p></div><h2 class=\"top\">Endereço</h2><div class=\"row center-xs center-sm center-md center-lg around-xs around-sm around-md around-lg content\"><p>Av. Getúlio Vargas, 3646, Bairro São João Bosco, 76803-742 Porto Velho - Rondônia</p></div></div></div></div><rcv-footer></rcv-footer></div>");
$templateCache.put("app/_components/footer/footer.html","<footer class=\"row center-xs center-sm center-md center-lg\" ng-controller=\"MainController as main\"><div class=\"col-lg-9 col-md-12 col-sm-12 col-xs-12\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 start-xs start-sm start-md start-lg\"><div class=\"box social\"><ul><li><img src=\"../../assets/images/redeconv-small.svg\"></li><li><a target=\"_blank\" href=\"https://facebook.com/redeconv\"><img src=\"../../assets/images/fb-small.svg\"></a></li><li><a target=\"_blank\" href=\"https://twitter.com/redeconv\"><img src=\"../../assets/images/tw-small.svg\"></a></li><li><a target=\"_blank\" href=\"https://www.linkedin.com/company/redeconv-do-brasil\"><img src=\"../../assets/images/in-small.svg\"></a></li></ul></div></div></div><div class=\"box top\"><div class=\"row between-sm between-md between-lg\"><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-12\"><div class=\"box\"><ul class=\"col\"><li><a href=\"\" ui-sref=\"sobre\" ng-click=\"main.gotoElement(\'nav\');\">Sobre nós</a></li><li><a href=\"\" ui-sref=\"faq\" ng-click=\"main.gotoElement(\'nav\');\">Perguntas frequentes</a></li><li><a href=\"\">Contratar</a></li></ul></div></div><div class=\"col-lg-4 col-md-3 col-sm-4 col-xs-12\"><div class=\"box\"><h3>Horário de funcionamento</h3><ul class=\"col\"><li>Segunda à sexta-feira</li><li>08h00 - 11h30 / 13h30 - 17h30</li></ul></div></div><div class=\"col-lg-3 col-md-3 col-sm-4 col-xs-12\"><div class=\"box\"><h3>Contato</h3><ul class=\"col\"><li>+55 69 3224-1552</li><li>contato@redeconv.com.br</li></ul></div></div></div></div><div class=\"box bottom\">© 2016 Redeconv do Brasil. Todos os direitos reservados.</div></div></footer>");
$templateCache.put("app/_components/navbar/navbar.html","<div class=\"row middle-lg middle-md middle-sm middle-xs center-xs center-sm center-md center-lg navigation\" id=\"nav\"><div class=\"col-lg-9 col-md-12 col-sm-12 col-xs-12\" ng-controller=\"MainController as main\"><div class=\"row middle-lg middle-md middle-sm middle-xs between-xs between-sm between-md between-lg\"><div class=\"col-xs-12 col-sm-3 col-md-2 col-lg-2\"><div class=\"box\"><span class=\"brand\"><a href=\"/\" ui-sref=\"home\" ng-click=\"main.gotoElement(\'nav\');\"><img src=\"../../assets/images/logo.svg\"></a></span></div></div><div class=\"col-xs-12 col-sm-5 col-md-8 col-lg-7 hidden-xs\"><ul class=\"menu\"><li><a href=\"/\" ng-click=\"main.gotoElement(\'vantagens\');\">Vantagens</a></li><li><a href=\"/\" ng-click=\"main.gotoElement(\'contratar\');\">Contratar</a></li><li><a href=\"\" ui-sref=\"sobre\" ng-click=\"main.gotoElement(\'nav\');\">Sobre</a></li><li><a href=\"\" ui-sref=\"faq\" ng-click=\"main.gotoElement(\'nav\');\">Perguntas Frequentes</a></li></ul></div><div class=\"col-xs-12 end-sm col-sm-3 col-md-2 col-lg-2\"><div class=\"box navmenu\"><ul class=\"nav\"><li class=\"button-dropdown\"><a href=\"javascript:void(0);\" ng-click=\"main.toggleDD();\" class=\"dropdown-toggle btn btn-primary\">Acesso ao Portal</a><ul class=\"dropdown-menu\"><li><a href=\"http://sistema.redeconv.com.br/ae/main/login\" ng-click=\"main.toggleDD();\">Estabelecimento</a></li><li><a href=\"http://sistema.redeconv.com.br/aa/main/login\" ng-click=\"main.toggleDD();\">Associado</a></li><li style=\"padding-bottom: 8px;\"><a href=\"http://sistema.redeconv.com.br/aa/main/login?redir=instituicao\" ng-click=\"main.toggleDD();\">Instituição</a></li><li style=\"border-top: 1px solid #f2f2f2;\"><a href=\"http://sistema.redeconv.com.br/ar/main/login\" ng-click=\"main.toggleDD();\">Corporativo</a></li></ul></li></ul></div></div></div></div></div>");}]);